import { Component } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { LOGIN_STATUS } from "src/app/config/constants";

@Component({
    selector: "cc-registration-error",
    standalone: true,
    templateUrl: "./registration-error.component.html",
    styleUrl: "./registration-error.component.scss",
})
export class RegistrationErrorComponent {
    currentYear = new Date().getFullYear();
    buttonLabel = "";

    constructor() {
        this.buttonLabel =
            localStorage.getItem(LOGIN_STATUS) === "true"
                ? "Go to Homepage"
                : "Return to Login";
    }

    logout() {
        location.href = "/";
    }
}
